import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography
} from "@mui/material";
import styles from "../../../styles.module.css";
import pickupService from "../../../services/pickup.Service";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  SearchInput,
  StyledTableCell,
  StyledTableRow
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import driverMasterService from '../../../services/masters/driverMaster.Service';
import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
import customerMasterService from "../../../services/masters/customerMaster.Service"
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
const Listpickupentry = () => {
  const dispatch = useDispatch();

  // Define defaultRowsPerPage with fallback for undefined pickup_entry
  const defaultRowsPerPage = useSelector(state => state.pickup_entry?.rows_per_page || 15);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const totalCount = useSelector(state => state.pickup_entry?.total_count || 0);
  const [rows, setRows] = useState([]);

  const [driverList, setDriver] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [vehicleList, setVehicle] = useState([]);
  const [cylinderList, setCylinder] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const [driverData, customerData, cylinderData, vehicleData, pickup_entry] = await Promise.all([
          driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
          vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
          pickupService.getPickupList({ page: 0, size: 999, searchKey: "" }),

        ]);

        setDriver(driverData);
        setCustomer(customerData);
        setCylinder(cylinderData);
        setVehicle(vehicleData);


      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }

    fetchData();
  }, []);


  console.log(rows, "fgsd");

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await pickupService.getPickupList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller, searchKey]);

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController(prev => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);

    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };

    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  const HandleSort = (field) => {
    const newSortBy = sortBy === field ? null : field;
    setSortBy(newSortBy);

    if (newSortBy) {
      rows.sort((a, b) => {
        if (a[newSortBy] < b[newSortBy]) return -1;
        if (a[newSortBy] > b[newSortBy]) return 1;
        return 0;
      });
    } else {
      fetchData();
    }
  };

  const handleDelete = (row) => {
    setIsDelete(true);
    setDeleteInfo(row);
  };

  const deleteRecord = async (id) => {
    try {
      await pickupService.editDeletePickup({
        pickup_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleClose = () => {
    setIsDelete(false);
    setDeleteInfo(null);
  };
  const fields = ["entry_date", "entry_no", "customer_name", "no_cylinder", "driver", "vehical_no",];
  const labels = ["Entry Date", "Pickup Entry No", "Customer Name", "No Of Cylinders", "Driver", "Vehicle No"];

  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });
  const customerMap = useMemo(() => {
    return customerList.reduce((acc, curr) => {
      acc[curr.cust_id] = curr.cust_name;
      return acc;
    }, {});
  }, [customerList]);

  const driverMap = useMemo(() => {
    return driverList.reduce((acc, curr) => {
      acc[curr.driver_id] = curr.driver_name;
      return acc;
    }, {});
  }, [driverList]);

  const vehicleMap = useMemo(() => {
    return vehicleList.reduce((acc, curr) => {
      acc[curr.vehicle_id] = curr.vehicle_no;
      return acc;
    }, {});
  }, [vehicleList]);
  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Cylinder Collcetion Entry List" }]} />

        <HeaderSection
          title="Cylinder Collcetion Entry List"
          addNewPath="/storeEntries/add-pickup"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Pickup_Entry_List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />


        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>

                  <StyledTableCell align="left" className={styles.table_head}>Entry Date</StyledTableCell>
                  <StyledTableCell align="right" className={styles.table_head}>Collcetion Entry No</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Customer Name</StyledTableCell>
                  <StyledTableCell align="right" className={styles.table_head}>No Of Cylinders</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Driver Name</StyledTableCell>
                  <StyledTableCell align="left" className={styles.table_head}>Vehicle No</StyledTableCell>

                  <StyledTableCell align="center" className={styles.table_head}>Action</StyledTableCell>

                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) && rows.map((row) => (
                  <StyledTableRow key={row.pickup_id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <StyledTableCell align="left" className={styles.list_table_body}>
                      {row.entry_date}
                    </StyledTableCell>
                    <StyledTableCell align="right" className={styles.list_table_body}>
                      {row.entry_no}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={styles.list_table_body}>
                      {customerMap[row.from_customer_id] || 'Unknown'}
                    </StyledTableCell>
                    <StyledTableCell align="right" className={styles.list_table_body}>
                      {row.no_cylinder}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={styles.list_table_body}>
                      {driverMap[row.driver_id] || 'Unknown'}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={styles.list_table_body}>
                      {vehicleMap[row.to_tempo] || 'Unknown'}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/storeEntries/add-pickup"
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>


        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.pickup_id || null}
          displayName={deleteInfo?.pickup_id || ""}
        />

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default Listpickupentry;